export default __webpack_public_path__ + "static/media/cf2023_kormidlo_lod.9ee37302.svg";